"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zip = {
    name: 'zip-geo',
    altName: 'zip',
    tableType: 'dim',
    grain: [
        '::key',
    ],
    tableGrain: ['!zip-geo'],
    foreignKeys: [],
};
const zipMonthly = {
    name: 'zip-geo-monthly',
    altName: 'zip-monthly',
    tableType: 'dim',
    grain: [
        '::key',
    ],
    tableGrain: ['!zip-geo-monthly'],
    foreignKeys: [],
};
exports.default = [zip, zipMonthly];
